const locale = {
  /** General */
  category: 'categoria',
  settings: 'impostazioni',

  /** Navbar */
  navbar: {
    currentSpeed: 'velocità attuale',
    freeSpace: 'spazio libero',
    topActions: {
      openSettings: 'apri le impostazioni',
      searchNew: 'cerca nuovi torrent'
    }
  },

  /** Modals */
  modals: {
    add: {
      title: 'Aggiungi un Torrent',
      selectFiles: 'Seleziona i file'
    }
  }
}

export default locale
